import React from 'react';

interface AppTopbarProps {
    onToggleMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    layoutColorMode: string;
    mobileTopbarMenuActive: boolean;
    onMobileTopbarMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onMobileSubTopbarMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const AppTopbar: React.FC<AppTopbarProps> = ({
    onToggleMenuClick,
    layoutColorMode,
    mobileTopbarMenuActive,
    onMobileTopbarMenuClick,
    onMobileSubTopbarMenuClick
}) => {
    return (
        <div className="layout-topbar">
            <button type="button" className="p-link layout-menu-button layout-topbar-button" onClick={onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>
            <div className="layout-topbar-logo">
                <span>Industrial Coatings Dashboard</span>
            </div>
        </div>
    );
};

export default AppTopbar;
